import { React, memo, useContext } from 'react';
import { AppContext } from 'App';
import Button from 'b2b-ui-components-lib/lib/components/button';
import './ContactUs.scss';

function ContactUs() {
  const { pageData } = useContext(AppContext);
  const { title, connect_content, login_content, img_url, contact_number, redirect_to_login } = pageData?.contact;
  return (
    <section className="contact_us_section" id="contactSection">
      <div className="container">
        <div className="contact_us_inside">
          <div className="outer_row">
            <div className="outer_col_content">
              <h2>{title}</h2>
              <div className="content_row">
                <div className="content_col">
                  <h4>{connect_content}</h4>
                  <div className="action_btn">
                    <Button onClick={() => window.open(`tel:${contact_number}`)} displayName={`Call - ${contact_number}`} variant="activebtn"></Button>
                  </div>
                </div>
                <div className="content_col">
                  <h4>{login_content}</h4>
                  <div className="action_btn">
                    <Button onClick={() => window.open(redirect_to_login, '_blank')} displayName="Login Now" variant="outlinebtn"></Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="outer_col_img">
              <img src={img_url} alt="Blob" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default memo(ContactUs);
